/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { CSSProperties } from 'react';
import { themeColors } from './Constants';

type Props = {
  percentage: number;
  style?: CSSProperties;
};

function ProgressBar(props: Props) {
  const { percentage, style } = props;
  const styles = getStyles(percentage);
  return (
    <div
      className="bp3-progress-bar bp3-intent-primary bp3-no-animation bp3-no-stripes"
      style={{ ...styles.container, ...style }}
    >
      <div className="bp3-progress-meter" style={styles.progressMeter}>
        {`${percentage}%`}
      </div>
    </div>
  );
}

const getStyles = (percentage: number) => ({
  container: {
    height: 20,
    borderRadius: 20,
    backgroundColor: themeColors.lightGrey,
    boxShadow: '0 0 0 1px #fff, 0 0 0 2px #ddd',
  },
  progressMeter: {
    width: `${percentage}%`,
    borderRadius: 20,
    textAlign: 'center' as any,
    color: themeColors.lightGrey,
    fontSize: 12,
  },
});

export default ProgressBar;
